export default __webpack_public_path__ + "static/videoInHome-e7a8129a7ac944868ea6430c54043165.mp4";